import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../theme';
import { FA_SELECTOR } from '../styles/variables';

export const useEmailNotificationsStyles = createStyles(({ token }) => ({
  emailNotifications: {
    [FA_SELECTOR]: {
      color: ThemeColors.COLOR_RED,
    },

    '.ant-btn.ant-btn-primary': {
      [FA_SELECTOR]: {
        color: ThemeColors.COLOR_WHITE,
      },
    },

    form: {
      marginBottom: 0,
    },

    '.ant-checkbox-wrapper': {
      flexDirection: 'column-reverse',
      gap: ThemeSpaces.SPACE_XXS,
    },
  },
  stackedTwoLinesSpacing: {
    marginTop: ThemeSpaces.SPACE_XXS,
  },
  overrideSwitchOn: {
    color: `${ThemeColors.COLOR_RED2} !important`,
  },
  overrideSwitchOff: {
    color: `${ThemeColors.COLOR_GREY3} !important`,
    transform: 'rotateZ(180deg)',
  },
  addNotificationButton: {
    height: 32,
    borderRadius: token.borderRadius,
    border: `1px solid ${ThemeColors.COLOR_RED}`,
    backgroundColor: ThemeColors.COLOR_WHITE,
    padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 500,
    fontSize: token.fontSizeLG,
    letterSpacing: '-0.18px',
    color: ThemeColors.COLOR_RED,
  },
  activeNotificationsTitle: {
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
    fontSize: token.fontSizeLG,
    textTransform: 'uppercase',
    color: ThemeColors.COLOR_GREY_BLUISH5,
    lineHeight: 1,
  },
  activeNotificationsNone: {
    fontWeight: 500,
    fontSize: token.fontSizeLG,
    color: ThemeColors.COLOR_GREY6,
    lineHeight: 1,
    fontStyle: 'italic',
    marginTop: -ThemeSpaces.SPACE_XXS,
  },
  booleanPreview: {
    '&.ant-tag': {
      display: 'flex',
      backgroundColor: ThemeColors.COLOR_GREY_BLUISH2,
      borderColor: ThemeColors.COLOR_GREY_BLUISH2,
      borderRadius: token.borderRadiusLG,
      height: 20,
      color: ThemeColors.COLOR_WHITE,
      fontFamily: ThemeFont.FONT_FAMILY,
      fontSize: token.fontSizeSM,
      fontWeight: 500,
      marginRight: 0,

      [FA_SELECTOR]: {
        color: ThemeColors.COLOR_WHITE,
        marginRight: ThemeSpaces.SPACE_XS,
      },
    },
  },
  otherEmailsControls: {
    display: 'flex',
    flexDirection: 'column',
    gap: ThemeSpaces.SPACE_SM,
  },
  otherEmailsLabel: {
    fontSize: token.fontSizeSM,
    color: ThemeColors.COLOR_GREY_BLUISH,
  },
  otherEmailsValue: {
    fontSize: token.fontSizeLG,
    color: ThemeColors.COLOR_GREY3_5,
    lineHeight: 1.125,
  },
  card: {
    borderRadius: token.borderRadius,
    boxShadow: `1px 1px 6px ${ThemeColors.COLOR_GREY8_1}`,
  },
  cardHeader: {
    height: 32,
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
    fontSize: token.fontSizeLG,
    letterSpacing: '-0.18px',
    color: ThemeColors.COLOR_GREY_BLUISH5,
    borderTopLeftRadius: token.borderRadius,
    borderTopRightRadius: token.borderRadius,
    border: `1px solid ${ThemeColors.COLOR_GREY8_7}`,
  },
  cardHeaderDark: {
    justifyContent: 'space-between',
    color: ThemeColors.COLOR_WHITE,
    backgroundImage: `linear-gradient(180deg, ${ThemeColors.COLOR_GREY_DARK0_5}, ${ThemeColors.COLOR_GREY_DARK0_7})`,
    fontFamily: ThemeFont.FONT_FAMILY,
    fontWeight: 500,

    [FA_SELECTOR]: {
      color: ThemeColors.COLOR_WHITE,
      display: 'block',
    },
  },
  cardHeaderLight: {
    gap: ThemeSpaces.SPACE_SM,
    backgroundColor: ThemeColors.COLOR_WHITE2,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
  },
  cardBody: {
    padding: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px`,
    backgroundColor: ThemeColors.COLOR_WHITE,
    borderBottomLeftRadius: token.borderRadius,
    borderBottomRightRadius: token.borderRadius,
  },
  cardBodyCompact: {
    '.ant-btn-lg': {
      fontSize: token.fontSize,
      letterSpacing: '-0.1px',
    },
  },
  subform: {
    padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
  },
  subformDisabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  overrideLabel: {
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
    fontSize: token.fontSizeLG,
  },
  overrideValue: {
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
    fontSize: token.fontSize,
    textTransform: 'uppercase',

    label: {
      display: 'flex',
      alignItems: 'center',
      gap: ThemeSpaces.SPACE_XS,
    },
  },
}));
